import React, { useState } from 'react';
import { Button, Inserate, ModalPortal, NamedLink } from '../../components';
import css from './EditListingPhotosForm.css';

export default () => {
    const [open, setOpen] = useState(false);

    return (
        <>
            <span
                role="link"
                name="InseratePage"
                className={css.titleAlertLink}
                onClick={() => setOpen(true)}
            >
                Richtlinie ansehen
            </span>

            {open && (
                <ModalPortal
                    isOpen
                    isSticky
                    id="PrivacyPolicyEditListingModal"
                    onClose={() => setOpen(false)}
                    contentClassName={css.titleAlertModalContent}
                    containerClassName={css.titleAlertContainer}
                    containerClassNameJoined
                >
                    <h4 className={css.titleAlertHeading}>Inserate-Richtlinie</h4>
                    <Inserate />
                    <footer>
                        <Button>Schliessen</Button>
                    </footer>
                </ModalPortal>
            )}
        </>
    );
};
